import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/commerce-services/commerce-services/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Edition = makeShortcode("Edition");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`​`}<Edition name="paas" mdxType="Edition" /></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Environment`}</th>
          <th parentName="tr" {...{
            "align": "right"
          }}>{`Endpoint`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Testing`}</strong></td>
          <td parentName="tr" {...{
            "align": "right"
          }}><inlineCode parentName="td">{`https://catalog-service-sandbox.adobe.io/graphql`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Production`}</strong></td>
          <td parentName="tr" {...{
            "align": "right"
          }}><inlineCode parentName="td">{`https://catalog-service.adobe.io/graphql`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <p>{`​`}<Edition name="saas" mdxType="Edition" /></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Environment`}</th>
          <th parentName="tr" {...{
            "align": "right"
          }}>{`Endpoint`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Testing`}</td>
          <td parentName="tr" {...{
            "align": "right"
          }}><inlineCode parentName="td">{`https://na1-sandbox.api.commerce.adobe.com/{{tenant-id}}/graphql`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Production (Not available yet)`}</td>
          <td parentName="tr" {...{
            "align": "right"
          }}><inlineCode parentName="td">{`https://na1.api.commerce.adobe.com/{{tenant-id}}/graphql`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <p><strong parentName="p">{`URL structure for SaaS endpoints`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-text"
      }}>{`https://<region>-<environment>.api.commerce.adobe.com/<tenantId>/graphql
`}</code></pre>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`<region>`}</inlineCode>{` is the cloud region where your instance is deployed.`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`<environment>`}</inlineCode>{` is the environment type, such as `}<inlineCode parentName="li">{`sandbox`}</inlineCode>{`. If the environment is production, this value is omitted.`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`<tenantId>`}</inlineCode>{` is the unique identifier for your organization's specific instance within the Adobe Experience Cloud.`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      